import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator, ValidationResult } from '../../../../helpers/cell-validators'
import getDistance from '../../../../helpers/fields-calculation/stamps/get-distance'

const createErrorResult = (message: string, token: GlobalToken): ValidationResult => ({
    message,
    bgColor: token.colorErrorBg,
    color: token.colorErrorText || token.colorError,
})

export const validateMaterialEfficiency: CellValidator = (record, token: GlobalToken) => {
    const stamp = record.stamp

    if (!stamp) {
        return null
    }

    const distance = getDistance(stamp)

    if (distance < 2) {
        return createErrorResult('М/э меньше 2', token)
    }

    if (distance > 10) {
        return createErrorResult('М/э больше 10', token)
    }

    return null
}

